<div class="reg-container">
  <div class="reg-form-folder">
    <div class="reg-form">
      <div class="reg-form-header">
        <h2>
          Войти или зарегистрироваться
        </h2>
      </div>

      <!--Форма для ввода номера -->
      <form autocomplete="off" *ngIf="!codeSent"  [formGroup]="phoneForm" class="reg-form__form">

        <div class="reg-form__type-selector">
          <div class="reg-form__type-selector__item" [ngClass]="userType === 'client' ? 'active' : ''">
            <span (click)="switchUserType('client')">Клиент</span>
          </div>
          <div class="reg-form__type-selector__item" [ngClass]="userType === 'agent' ? 'active' : ''">
            <span (click)="switchUserType('agent')">Агент</span>
          </div>
          <div class="reg-form__type-selector__item" [ngClass]="userType === 'partner' ? 'active' : ''">
            <span (click)="switchUserType('partner')">Партнер</span>
          </div>
        </div>

        <p class="reg-form__text">Укажите номер телефона, на который поступит смс с кодом</p>
        <div class="reg-form__group">
          <div class="phone">
        <span class="phone__btn-language">
          <span class="phone__btn-language-icon" [style.background-image]="'url(../../assets/images/flags/ru.png)'"></span>
        </span>
            <div class="phone__code">
              <span class="code">+7</span>
            </div>
            <input
              class="reg-form__input"
              [formControl]="$any(phoneForm.get('phone'))"
              [mask]="mask"
              (keyup)="onKeyUp($event, 'phone')"
              placeholder="000 000-00-00"
              type="text"
            />
          </div>
        </div>
        <app-button
          [type]="'button'"
          [size]="'large-md'"
          (click)="onPhoneSend()"
          [square]="true"
        >
          Получить код
        </app-button>
      </form>

      <!--Форма для ввода номера + кода -->
      <form *ngIf="codeSent" [formGroup]="loginForm">
        <p class="reg-form__text">Введите последние 4 цифры номера входящего звонка или код из СМС
        </p>
        <div class="reg-form__group">
          <input
            class="reg-form__input text-center"
            [formControl]="$any(loginForm.get('code'))"
            (keyup)="onKeyUp($event, 'code')"
          />
        </div>
        <app-button [type]="'button'" (click)="onCodeSend()" [size]="'large-md'" [square]="true">
          Отправить код подтверждения
        </app-button>
        <div class="reg-form__count" *ngIf="timerIsActive">
          Отправить код повторно через
          <app-countdown-timer
            [timerSec]="60"
            [start]="timerIsActive"
            [reset]="!timerIsActive"
            (finished)="enableLimits()">
          </app-countdown-timer> сек.
        </div>
      </form>

      <p class="reg-form__agree">Нажимая кнопку «<b>Получить код</b>», вы подтверждаете свое согласие на <a href="#">обработку персональных данных</a> и получение<a href="#">рекламных рассылок</a> </p>
      <app-auth-social></app-auth-social>
    </div>
  </div>
</div>
